module.exports = __webpack_public_path__ + "static/img/news.a0f61b3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mastheads/news.jpg
// module id = CAkR
// module chunks = 1